import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import './ChooseCard.scss';


class ChooseCard extends Component {
  constructor(props) {
    super(props);

    this.onClickApply = this.onClickApply.bind(this);
  }
  onClickApply() {
    this.props.onClickApply(this.props.card);
  }
  render() {
    let checkmark;
    if(this.props.selected) {
      checkmark = <div className="check-mark"></div>
    }
    return (
      <div className="choose-card">
        <div className={"card-image "+this.props.card.type}>{checkmark}</div>
        <h1>{this.props.card.name}</h1>
        <h2>{this.props.card.benefits}</h2>
        <dl>
          <dt>Annual fee</dt>
          <dd>{this.props.card.fee}</dd>
        </dl>
        <dl>
          <dt>Annual interest rate</dt>
          <dd>{this.props.card.interest.toFixed(2)}%</dd>
        </dl>
        <dl>
          <dt>Rewards</dt>
          <dd>{this.props.card.rewards}</dd>
        </dl>
        <Button color="primary" onClick={this.onClickApply}>Apply</Button>
      </div>);
  }
}

ChooseCard.defaultProps= {  
  card: {},
  interestRate: 0,
  selected: false,
  onClickApply:() => {}
};

ChooseCard.propTypes = {
  card: PropTypes.object,
  selected: PropTypes.bool,
  onClickApply: PropTypes.func
};
export default ChooseCard;


// WEBPACK FOOTER //
// ./src/components/ChooseCard/ChooseCard.js